function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { FormInput as FormInputSemantic } from 'semantic-ui-react';
import InputCounter from "./InputCounter";
import { getRest } from "../../utils";

/**
 * Champ de saisie avec state.
 *
 * @class Input
 * @extends {React.PureComponent}
 */
import { jsx as _jsx } from "react/jsx-runtime";
var Input = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(Input, _React$PureComponent);
  function Input(props) {
    var _this;
    _this = _React$PureComponent.call(this, props) || this;
    /**
       * Debounce the changes by 300ms.
       *
       * @memberof Input
       */
    _this.bouncedChange = _.debounce(function (event, data) {
      _.invoke(_this.props, 'onChange', event, data);
    }, 300);
    /**
       * Gestion des modifications.
       *
       * @memberof Input
       */
    _this.handleChange = function (event, data) {
      var _this$props = _this.props,
        onChange = _this$props.onChange,
        debounced = _this$props.debounced;
      var _ref = event || {},
        target = _ref.target;
      var _ref2 = target || {},
        value = _ref2.value;
      _this.setState({
        value: value
      });
      if (debounced) {
        _this.bouncedChange(Object.assign({}, event), data);
      } else if (onChange) {
        onChange(event, data);
      }
    };
    var _value = props.value;
    _this.state = {
      value: _value,
      prevValue: _value
    };
    return _this;
  }

  /**
     * @description
     *
     * @static
     * @memberof Input
     */
  Input.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, previousState) {
    var prevValue = previousState.prevValue;

    // Compare the incoming prop to previous prop
    var value = prevValue !== nextProps.value ? nextProps.value : previousState.value;
    return {
      // Store the previous props in state
      prevValue: nextProps.value,
      value: value
    };
  };
  var _proto = Input.prototype;
  /**
     * Render the component.
     *
     * @returns
     * @memberof Input
     */
  _proto.renderDefault = function renderDefault() {
    var _this$props2 = this.props,
      name = _this$props2.name,
      label = _this$props2.label,
      icon = _this$props2.icon,
      width = _this$props2.width,
      placeholder = _this$props2.placeholder,
      required = _this$props2.required;
    var value = this.state.value;
    var rest = getRest(Input, this.props);
    var inputProps = {
      key: name,
      name: name,
      label: label,
      placeholder: placeholder,
      value: value,
      icon: icon,
      width: width,
      onChange: this.handleChange,
      required: required
    };
    return /*#__PURE__*/_jsx(FormInputSemantic, Object.assign({}, _.omit(rest, ['debounced']), inputProps));
  }

  /**
     * Render the component.
     *
     * @returns
     * @memberof Input
     */;
  _proto.render = function render() {
    var maxLength = this.props.maxLength;
    if (!_.isNil(maxLength)) {
      return /*#__PURE__*/_jsx(InputCounter, Object.assign({}, _.omit(this.props, ['debounced']), {
        onChange: this.handleChange
      }));
    }
    return this.renderDefault();
  };
  return Input;
}(React.PureComponent);
Input.handledProps = ["debounced", "icon", "label", "maxLength", "name", "onChange", "placeholder", "required", "value", "width"];
Input.propTypes = {
  /** Valeur */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Nom */
  name: PropTypes.string,
  /** Label */
  label: PropTypes.string,
  /** Icone */
  icon: PropTypes.string,
  /** Largeur */
  width: PropTypes.number,
  /** Placeholder */
  placeholder: PropTypes.string,
  /** Required. */
  required: PropTypes.bool,
  /** Callback on change. Discouraged use for value's update. */
  onChange: PropTypes.func,
  /** Whether or not the changes are debounced. */
  debounced: PropTypes.bool,
  /** Nombre de caractères maximum du champ */
  maxLength: PropTypes.number
};
Input.defaultProps = {
  value: '',
  debounced: true
};
export default Input;